import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import apps from '@/store/modules/apps'
import auth from '@/store/modules/auth'
import http from '@/store/modules/http'
import customerBase from '@/store/modules/customer_base'
import paymentLinks from './modules/payment-links'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    apps,
    auth,
    http,
    customerBase,
    paymentLinks
  },
  plugins: [
    createPersistedState({
      key: 'piriod',
      paths: [
        'apps.referrerUrl',
        'apps.selectedAddons',
        'apps.selectedPlans',
        'apps.signupsDetail',
        'paymentLinks.intentsDetail',
        'paymentLinks.linksDetail'
      ]
    })
  ]
})
